import { createFileRoute } from '@tanstack/react-router';

import { DeliveryPage, type DeliveryTab } from '@/features/delivery/DeliveryPage';

const tabValues: DeliveryTab[] = ['methods', 'settings', 'quote', 'payment'];

export interface DeliverySearch {
  /** Вкладка раздела; по умолчанию — способы доставки. */
  tab?: DeliveryTab;
}

/**
 * Вкладка живёт в адресе: ссылку на «Калькулятор» или «Оплату» пересылают коллеге,
 * и открыться она должна тем же экраном. Чужие значения отбрасываются к умолчанию.
 */
export const Route = createFileRoute('/_app/delivery')({
  validateSearch: (search: Record<string, unknown>): DeliverySearch => ({
    tab: tabValues.find((value) => value === search.tab && value !== 'methods'),
  }),
  component: DeliveryRoute,
});

function DeliveryRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <DeliveryPage
      tab={search.tab ?? 'methods'}
      onTabChange={(tab) =>
        void navigate({
          search: { tab: tab === 'methods' ? undefined : tab },
          // Смена вкладки — не шаг навигации: «назад» должно уводить из раздела,
          // а не перебирать вкладки.
          replace: true,
        })
      }
    />
  );
}
